module.exports = __webpack_public_path__ + "static/img/anxun14.4cbb9398.png";